import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { FormInput } from './form-input.comp';
import { createLegacyDeprecatedInputDriver } from '../../primitives/deprecated-input/input.legacy-driver';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createFormInputLegacyDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, '.form-input', FormInput.name);
    var inputDriver = createLegacyDeprecatedInputDriver(wrapper);
    return {
        getValue: function () { return inputDriver.getValue(); },
        enterValue: function (value) { return inputDriver.enterValue(value); },
        pressEnter: function () { return inputDriver.pressEnter(); },
        isDisabled: function () { return inputDriver.isDisabled(); },
        isReadOnly: function () { return inputDriver.isReadOnly(); },
        isValid: function () { return !baseDriver.hasClass('invalid'); },
        getPlaceholder: function () { return inputDriver.getPlaceholder(); },
        getValidationMessage: function () {
            return baseDriver.isChildVisible('.validation-msg') ?
                baseDriver.find('.validation-msg').getText() : '';
        },
        getLabel: function () { return baseDriver.find('.label-text').getText(); }
    };
};
export var createFormInput = function (props) {
    var elem = renderAndMountComponent(React.createElement(FormInput, __assign({}, props)));
    return createFormInputLegacyDriver(elem);
};
//# sourceMappingURL=form-input.legacy.driver.js.map